import { getRuntimeBaseUrl } from "@arbolus-technologies/utils";
import { datadogRum } from "@datadog/browser-rum";
import { createRoot } from "react-dom/client";
import "material-symbols";

import packageJson from "../package.json";

import "./i18n";

import "bootstrap/dist/css/bootstrap.min.css";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "./App.scss";
import "./app/assets/scss/styles.scss";
import "./app/assets/fonts/style.css";
import "simplebar/dist/simplebar.min.css";
import "intl-tel-input/build/css/intlTelInput.css";
import "./index.css";
import { ConfigProvider } from "antd";
import { Suspense, lazy } from "react";
import antTheme from "../../../libs/theme/src/lib/antd/light.json";
import { FullscreenLoader } from "./app/components/Loader/Loader";
const App = lazy(() => import("./App"));

const BASE_URL = getRuntimeBaseUrl();
const currentVersion = packageJson.version;

if (process.env.NX_PUBLIC_DATADOG_RUM_ACTIVE === "true") {
  datadogRum.init({
    applicationId: process.env.NX_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: process.env.NX_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: "datadoghq.eu",
    service: process.env.NX_PUBLIC_DATADOG_SERVICE,
    env: process.env.NX_PUBLIC_DATADOG_ENV,
    version: currentVersion,
    sessionSampleRate: (() => {
      const value = parseInt(
        process.env.NX_PUBLIC_DATADOG_RUM_SESSION_SAMPLE_RATE ?? "",
        10
      );
      return Number.isNaN(value) ? 100 : value;
    })(),
    sessionReplaySampleRate: (() => {
      const value = parseInt(
        process.env.NX_PUBLIC_DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE ?? "",
        10
      );
      return Number.isNaN(value) ? 100 : value;
    })(),
    traceSampleRate: (() => {
      const value = parseInt(
        process.env.NX_PUBLIC_DATADOG_RUM_TRACE_SAMPLE_RATE ?? "",
        10
      );
      return Number.isNaN(value) ? 10 : value;
    })(),
    traceContextInjection: "sampled",
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      { match: BASE_URL || "", propagatorTypes: ["tracecontext", "datadog"] }
    ],
    beforeSend: (event) => {
      // Filter out Chrome extension IPC errors (e.g. from password managers on the login page)
      if (
        event.type === "error" &&
        event.error.message?.includes("Object Not Found Matching Id")
      ) {
        return false;
      }
      return true;
    }
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <ConfigProvider theme={antTheme}>
    <Suspense fallback={<FullscreenLoader />}>
      <App />
    </Suspense>
  </ConfigProvider>
);

localStorage.setItem(
  "APP_VERSION",
  // COMMIT_HASH provided by webpack.config.js
  // @ts-ignore
  `${process.env.NX_PUBLIC_ENV}-${COMMIT_HASH}`
);
